import { string, object, boolean, date, bool } from "yup";
import parse from "date-fns/parse";
import differenceInYears from "date-fns/differenceInYears";
import { DOCUMENT_TYPES } from "../../../constants/documents";
import { CLIENT_TYPES } from "../../../constants/personaldata";

export const quoteSchema = object().shape({
    documentExists: boolean(),
    documentType: string().required(),
    documentNumber: string()
        .required("DNI requerido")
        .when("documentType", {
            is: DOCUMENT_TYPES.DNI,
            then: () => string().test("invalidLength", "DNI inválido", (val = "") => {
                return val.length === 0 || val.length === 8;
            }),
        }),
    cellphone: string()
        .matches(/^(?!.*(\d)\1{3})\d+$/, "N° celular inválido")
        .test("invalidLength", "N° celular inválido", (val = "") => {
            return val.length === 0 || val.length === 9;
        })
        .required("N° Celular requerido"),
    email: string()
        .required("Email requerido")
        .matches(/^(.{0}|.+@.+\..+)$/, "Email inválido"),
    names: string().when("documentExists", {
        is: false,
        then: () => string().required("Nombres requeridos"),
    }),
    firstSurname: string()
        .nullable()
        .when("documentExists", {
            is: false,
            then: () => string().required("Requerido"),
        }),
    lastSurname: string()
        .nullable()
        .when("documentExists", {
            is: false,
            then: () => string().required("Requerido"),
        }),
    birthDate: date()
        .nullable()
        .when("documentExists", {
            is: false,
            then: () => date()
                .transform((_, oldVal) => {
                    if (!oldVal) {
                        return undefined;
                    }
                    const isValidFormat = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(oldVal);
                    if (!isValidFormat) {
                        return undefined;
                    }
                    const parsedDate = parse(oldVal, "dd/MM/yyyy", new Date());
                    if (isNaN(parsedDate)) {
                        return undefined;
                    }
                    return parsedDate;
                })
                .typeError("Fecha de nacimiento inválida")
                .required("Fecha de nacimiento requerida")
                .test("min", "Debe ser mayor de 18 años", val => {
                    if (!val) {
                        return true;
                    }
                    const years = differenceInYears(new Date(), val);
                    return years >= 18;
                }),
        }),
    clientType: string()
        .nullable()
        .required("Tipo de cliente requerido"),
    whichEnsure: string()
        .nullable()
        .when("clientType", {
            is: CLIENT_TYPES.OWNER,
            then: () => string().required("Requerido"),
        }),
    housingType: string()
        .nullable()
        .required("Tipo de vivienda requerido"),
    contactConsent: bool(),
});
